var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVector1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 247,
    height: 236,
    viewBox: "0 0 247 236",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ddddd_15_30)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M201.986 130.917C202.457 127.189 202.81 123.461 202.81 119.5C202.81 115.539 202.457 111.811 201.986 108.083L226.823 88.8605C229.06 87.113 229.648 83.9675 228.236 81.4045L204.693 41.0955C203.281 38.5325 200.103 37.6005 197.513 38.5325L168.203 50.1825C162.082 45.5225 155.49 41.678 148.309 38.7655L143.836 7.893C143.483 5.097 141.011 3 138.068 3H90.9836C88.0408 3 85.5688 5.097 85.2157 7.893L80.7426 38.7655C73.5622 41.678 66.9703 45.639 60.8493 50.1825L31.539 38.5325C28.8316 37.484 25.7711 38.5325 24.3585 41.0955L0.816116 81.4045C-0.714141 83.9675 -0.00786672 87.113 2.22866 88.8605L27.0659 108.083C26.5951 111.811 26.2419 115.655 26.2419 119.5C26.2419 123.344 26.5951 127.189 27.0659 130.917L2.22866 150.139C-0.00786672 151.887 -0.596429 155.033 0.816116 157.596L24.3585 197.904C25.7711 200.467 28.9493 201.4 31.539 200.467L60.8493 188.818C66.9703 193.478 73.5622 197.322 80.7426 200.234L85.2157 231.107C85.5688 233.903 88.0408 236 90.9836 236H138.068C141.011 236 143.483 233.903 143.836 231.107L148.309 200.234C155.49 197.322 162.082 193.361 168.203 188.818L197.513 200.467C200.22 201.516 203.281 200.467 204.693 197.904L228.236 157.596C229.648 155.033 229.06 151.887 226.823 150.139L201.986 130.917ZM114.526 160.275C91.8076 160.275 73.3268 141.984 73.3268 119.5C73.3268 97.0155 91.8076 78.725 114.526 78.725C137.244 78.725 155.725 97.0155 155.725 119.5C155.725 141.984 137.244 160.275 114.526 160.275Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ddddd_15_30",
    x: -17.2174,
    y: 0.130435,
    width: 263.435,
    height: 296.848,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.145098 0 0 0 0 0.054902 0 0 0 0 0.145098 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_15_30"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.86957
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.86957
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.145098 0 0 0 0 0.054902 0 0 0 0 0.145098 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_15_30",
    result: "effect2_dropShadow_15_30"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10.7609
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.38043
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.145098 0 0 0 0 0.054902 0 0 0 0 0.145098 0 0 0 0.09 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_15_30",
    result: "effect3_dropShadow_15_30"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 24.3913
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.17391
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.145098 0 0 0 0 0.054902 0 0 0 0 0.145098 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_dropShadow_15_30",
    result: "effect4_dropShadow_15_30"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 43.7609
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.6087
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.145098 0 0 0 0 0.054902 0 0 0 0 0.145098 0 0 0 0.01 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect4_dropShadow_15_30",
    result: "effect5_dropShadow_15_30"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect5_dropShadow_15_30",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector1);
export default __webpack_public_path__ + "static/media/Vector (1).f086da5b8845c8fc1957867b5ff97ed0.svg";
export { ForwardRef as ReactComponent };